module.exports = __webpack_public_path__ + "img/icon-up-down.db6dedc4.svg";